import { BalanceContext } from '@app/collections/fortress/BalanceContext'
import { Button, Col, If, Row, Title } from '@app/components'
import { DynamicList } from '@app/generic-collections'
import { toCurrency } from '@app/utils'
import { OffRampDrawer, OnRampDrawer } from 'collections/flows'
import { useContext, useEffect, useState } from 'react'

import { AmericanFlagIcon } from '~public'

export const DigitalAccountList = ({ hideButton }: { hideButton?: boolean }) => {
  const [isOnDrawerOpen, setIsOnDrawerOpen] = useState(false)
  const [isOffDrawerOpen, setIsOffDrawerOpen] = useState(false)
  const { balance, fetchAccounts } = useContext(BalanceContext)

  useEffect(() => {
    fetchAccounts()
  }, [])

  const listData = [
    {
      icon: <AmericanFlagIcon style={{ width: 48, marginRight: 5 }} />,
      title: '$USD',
      description: 'United States Dollar',
      extra: () => (
        <Row align={'middle'} style={{ height: '100%' }}>
          <Col>${toCurrency(balance, false)}</Col>
        </Row>
      ),
    },
  ]

  const header = (
    <Row justify={'space-between'}>
      <Col>
        <Title level={4}>Digital Account</Title>
      </Col>
      <If condition={!hideButton}>
        <Row>
          <Col>
            <Button
              type="link"
              size="small"
              onClick={() => setIsOnDrawerOpen(!isOnDrawerOpen)}
              disabled={process.env.NEXT_PUBLIC_MAINTENANCE_MODE == 'true'}
            >
              Deposit cash
            </Button>
          </Col>
          <Col>
            <Button
              type="link"
              size="small"
              onClick={() => setIsOffDrawerOpen(!isOffDrawerOpen)}
              disabled={process.env.NEXT_PUBLIC_MAINTENANCE_MODE == 'true'}
            >
              Withdraw cash
            </Button>
          </Col>
        </Row>
      </If>
    </Row>
  )

  return (
    <>
      <DynamicList header={header} listData={listData} border="true" />
      <OnRampDrawer
        open={isOnDrawerOpen}
        toggleOpen={() => setIsOnDrawerOpen(!isOnDrawerOpen)}
        refresh={fetchAccounts}
      />
      <OffRampDrawer
        open={isOffDrawerOpen}
        toggleOpen={() => setIsOffDrawerOpen(!isOffDrawerOpen)}
        refresh={fetchAccounts}
      />
    </>
  )
}
